<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Gastos</h2>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button type="button" (click)="openModal(myModalAgregar)" class="boton fondoAmarillo blanco bold" > Agregar <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg> </button>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <span class="bold">Fecha Inicio</span>
                    <div class="input-group">
                        <input id="fecha_inicio" class="form-control"  [(ngModel)]="filtro.fecha_inicio" placeholder="Fecha Inicio yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Fecha Fin</span>
                    <div class="input-group">
                        <input id="fecha_fin" class="form-control"  [(ngModel)]="filtro.fecha_fin" placeholder="Fecha Fin yyyy-mm-dd" name="dp2b" ngbDatepicker #dp2b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp2b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Clasificación:</span>
                    <select class="form-control" [(ngModel)]="filtro.clasificacion" (change)="getCategoriasGastoClasificacion()" #clasificacionSelect>
                        <option value="">Selecciona Opción</option>
                        <option *ngFor = "let clasificacion of clasificaciones" [value]="clasificacion.id">{{clasificacion.nombre}}</option>
                    </select><br>
                </div>

                <div class="col-lg-3">
                    <span class="bold">Categoría:</span>
                    <select class="form-control" [(ngModel)]="filtro.categoria" #categoriaSelect>
                        <option value="">Selecciona Opción</option>
                        <option *ngFor = "let categoria of categoriasF" [value]="categoria.id">{{categoria.clave}} - {{categoria.nombre}}</option>
                    </select><br>
                </div>

                <div class="col-lg-3">
                    <button class="btn btn-success" (click)="getGastosFiltrados()">Filtrar</button>
                </div>

                <div class="col-lg-3">
                    <button class="btn btn-success" (click)="descargarExcel(categoriaSelect.value, clasificacionSelect.value)">Exportar a Excel</button>
                    
                </div>
            </div>

            <br>
            <div *ngIf="datosCliente.acceso_pagos == 1">
                <p style="font-style: italic;">Nota: Solo se muestran los últimos 100 registros, utiliza los filtros para tener
                más resultados.</p>
                <div class="row">
                    <div class="col-lg-3">
                        <p class="bold"><span class="amarillo2">Gastos:</span>  {{sumaGastos | currency}}</p>
                    </div>

                    <div class="col-lg-3">
                        <p class="bold"><span class="amarillo2">Pagos:</span>  {{sumaPagos | currency}}</p>
                    </div>

                    <div class="col-lg-3">
                        <p class="bold"><span class="amarillo2">Utilidad:</span>  {{utilidad | currency}}</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-11">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <td>Fecha</td>
                                <td>Categoría</td>
                                <td>Concepto</td>
                                <td>Monto</td>
                                <td>Ticket/Imagen</td>
                                <td *ngIf="datosCliente.acceso_pagos == 1">Editar</td>
                                <td *ngIf="datosCliente.acceso_pagos == 1">Eliminar</td>
                                <!-- <td>Link Registro</td> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor = "let gasto of gastos;  index as i;" >
                                <td>{{gasto.fecha}}</td>
                                <td>{{gasto.clave_s}}  {{gasto.clasificacion_s}} - {{gasto.categoria_s}}</td>
                                <td>{{gasto.concepto}}</td>
                                <td>{{gasto.monto | currency}}</td>
                                <td>
                                    <div *ngIf="gasto.imagen">
                                        <img src="{{enviroment}}{{gasto.imagen}}" width="200px">
                                    </div>
                                </td>
                                <td *ngIf="datosCliente.acceso_pagos == 1"><div >
                                  <button class="btn btn-info" (click)="editarGasto(gasto.id)">Editar</button>
                                </div></td>
                                <td *ngIf="datosCliente.acceso_pagos == 1"><div >
                                    <button class="btn btn-danger" (click)="eliminarGasto(gasto.id)">Eliminar</button>
                                </div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #myModalAgregar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Gasto</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span class="bold">Fecha</span>
        <div class="input-group">
            <input id="fecha_inicio" class="form-control"  [(ngModel)]="formulario.fecha" placeholder="Fecha yyyy-mm-dd" name="dp1b" (click)="dp1b.toggle()" ngbDatepicker #dp1b="ngbDatepicker">
            <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
            </button>
            </div>
        </div>

        <span>Concepto:</span>
        <input type="text" class="form-control" placeholder="Concepto" [(ngModel)]="formulario.concepto"><br>
        <span>Monto:</span>
        <input type="number" step=0.01 class="form-control" placeholder="Monto" [(ngModel)]="formulario.monto"><br>

        <span>Categoria:</span>
        <select class="form-control" [(ngModel)]="formulario.categoria">
            <option value="">Selecciona Opción</option>
            <option *ngFor = "let categoria of categorias" [value]="categoria.id">{{categoria.clave}} - {{categoria.nombre}} - {{categoria.clasificacion_s}}</option>
        </select><br>
       
        Imagen:<br>
        <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen"><br><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary fondoAmarillo" (click)="agregarGasto()">Agregar Gasto</button>
    </div>
</ng-template>



<div id="clickEditar" (click)="openModal(myModalEditar)"></div>

<ng-template #myModalEditar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Gasto</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span class="bold">Fecha</span>
        <div class="input-group">
            <input id="fecha_inicio" class="form-control"  [(ngModel)]="formularioEdit.fecha" placeholder="Fecha yyyy-mm-dd" name="dp1b" (click)="dp1b.toggle()" ngbDatepicker #dp1b="ngbDatepicker">
            <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
            </button>
            </div>
        </div>

        <span>Concepto:</span>
        <input type="text" class="form-control" placeholder="Concepto" [(ngModel)]="formularioEdit.concepto"><br>
        <span>Monto:</span>
        <input type="number" step=0.01 class="form-control" placeholder="Monto" [(ngModel)]="formularioEdit.monto"><br>

        <span>Categoria:</span>
        <select class="form-control" [(ngModel)]="formularioEdit.categoria">
            <option value="">Selecciona Opción</option>
            <option *ngFor = "let categoria of categorias" [value]="categoria.id">{{categoria.clave}} - {{categoria.nombre}} - {{categoria.clasificacion_s}}</option>
        </select><br>
        
        <div *ngIf="formularioEdit.imagen">
            <img src="{{enviroment}}{{formularioEdit.imagen}}" width="200px">
        </div>
        Imagen:<br>
        <input (change)="imageChangeEdit($event.target.files)" type="file"accept="image/*" id="imagen2"><br><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateGasto(gastoId)">Actualizar</button>
    </div>
</ng-template>